import { requestStart } from '~/request/Request'

// 用户登陆
export let LoginInfoQ = requestStart('login', 'app')

// 用户退出
export let LogoutInfoQ = requestStart('logout', 'app')

// 用户注册
export let RegisterInfoR = requestStart('register')

// 测试
export let DefaultInfoR = requestStart('defaults')

// 常见问题
export let saasForeign = requestStart('saasForeign', 'help')

// 申请
export let userApply = requestStart('userApply', 'ply')
// 获取首页信息
export let eaingeras = requestStart('eaingeras', 'saas-apply')



// WEBPACK FOOTER //
// ./request/api/Common.js